// extracted by mini-css-extract-plugin
module.exports = {"pill":"style_pill__ff95Z","white":"style_white__IaTmJ","blue":"style_blue__BG3VE","grey":"style_grey__3vQ8R"};